module.exports = __webpack_public_path__ + "assets/edit.5c47fec6.svg";